export default __webpack_public_path__ + "static/media/locks.2f25caf3.png";